import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * The show more component is a wrapper around another element
 * displaying a white number over a dark orverlay.
 */
@Component({
    selector: "h-show-more",
    templateUrl: "./show-more.component.html",
    styleUrls: ["./show-more.component.scss"],
})
export class ShowMoreComponent {
    /**
     * Number to display.
     */
    @Input()
    public moreNumber: number = 0;

    /**
     * Responsability of what to do when the button is pressed is delegated to parents.
     * emit on click and when space or enter keys pressed if element has focus.
     */
    @Output()
    public pressed: EventEmitter<void> = new EventEmitter<void>();

    /**
     * When enabled, the show-more button can receive keyboard focus.
     */
    @Input()
    public focusable: boolean = false;

    /**
     * When active, the show more will be marked with aria-haspopup="dialog".
     */
    @Input()
    public openDialog: boolean = false;

    public handleActivate(event: Event): void {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.pressed.emit();
    }
}
